import { Type, type Static } from '@sinclair/typebox';
import { PaginationQueryParamsSchema } from '../../shared/utils/pagination-query-params.schema';

export const GetFoldersListQuerySchema = PaginationQueryParamsSchema;

export const GetFolderParamsSchema = Type.Object({
  folder_id: Type.String({ description: 'ID of the Folder / Label to retrieve.' }),
});

export const CreateFolderBodySchema = Type.Object(
  {
    name: Type.String({ description: 'Name of the folder. For Gmail, name of the label.' }),
    parent_id: Type.Optional(Type.String({ description: '(Outlook only) ID of the parent folder.' })),
    text_color: Type.Optional(Type.String({ description: '(Gmail only) Hexadecimal color code for the text of the label.' })),
    background_color: Type.Optional(
      Type.String({ description: '(Gmail only) Hexadecimal color code for the background of the label.' }),
    ),
  },
  { additionalProperties: false },
);

export const DeleteFolderParamsSchema = Type.Object({
  folder_id: Type.String({ description: 'ID of the Folder / Label to delete.' }),
});

export const UpdateFolderParamsSchema = Type.Object({
  folder_id: Type.String({ description: 'ID of the Folder / Label to update.' }),
});

export const UpdateFolderBodySchema = Type.Object(
  {
    name: Type.Optional(Type.String({ description: 'Name of the folder. For Gmail, name of the label.' })),
    parent_id: Type.Optional(Type.String({ description: '(Outlook only) ID of the parent folder.' })),
    text_color: Type.Optional(Type.String({ description: '(Gmail only) Hexadecimal color code for the text of the label.' })),
    background_color: Type.Optional(
      Type.String({ description: '(Gmail only) Hexadecimal color code for the background of the label.' }),
    ),
  },
  { additionalProperties: false },
);

export type GetFoldersListQuery = Static<typeof GetFoldersListQuerySchema>;
export type GetFolderParams = Static<typeof GetFolderParamsSchema>;
export type CreateFolderBody = Static<typeof CreateFolderBodySchema>;
export type DeleteFolderParams = Static<typeof DeleteFolderParamsSchema>;
export type UpdateFolderParams = Static<typeof UpdateFolderParamsSchema>;
export type UpdateFolderBody = Static<typeof UpdateFolderBodySchema>;
